import React from 'react';
import { createPortal } from 'react-dom';
import { getMentionIcon } from '../../../../components/DeltaPreview';
import MentionBase from '../../../mentions/MentionBase';
import getEditorMentionUrl from '../../../utils/getEditorMentionUrl';
import Mention from '../../Mention';

class PreviewMention extends Mention {
  renderPortal() {
    const { contentNode, domNode } = this;
    const formats = this.statics.formats(domNode) || {};
    const { content } = formats;

    const { id, type, params } = this.statics.value(domNode);

    return createPortal(
      <MentionBase
        type={type}
        icon={getMentionIcon({ type, id })}
        content={
          formats['mention-text'] ||
          content ||
          getEditorMentionUrl({ id, type, params })
        }
      />,
      contentNode,
    );
  }
}

export default PreviewMention;
